export default __webpack_public_path__ + "static/media/Photo 10 - MR - ouverture sud chambre.77895578.png";